import { useState } from 'react';
import Select from 'react-select';
import { STRATEGY_OPTIONS } from '../options';
import { reilmAPI } from '../../../services/apiClient';
import { getStrategyLabel, resolveSelectOption } from '../utils';
import { STRATEGY_PILL, pillIndicator, pillStyles } from './pillSelect';

const DropdownIndicator = pillIndicator(STRATEGY_PILL);
const styles = pillStyles(STRATEGY_PILL);

const formatOptionLabel = ({ label }, { context }) => (
  context === 'value'
    ? <span className="block text-[12px] font-normal leading-none truncate">{label}</span>
    : <span className="text-[13px] text-brand-dark leading-none">{label}</span>
);

// Same save shape as StageCellEditor: the row changes only after the PATCH succeeds, and
// isDisabled={saving} rules out a second change racing the first.
const StrategyCellEditor = ({ params, onStrategyUpdate, onSaveOk, onSaveFailed }) => {
  const [saving, setSaving] = useState(false);
  const stored = params.row.raw?.strategy;
  // Most stored values are labels rather than STRATEGY_OPTIONS codes; they pass through as-is.
  const currentOption = resolveSelectOption(STRATEGY_OPTIONS, stored, getStrategyLabel);

  const handleChange = async (selected) => {
    if (!selected || selected.value === stored) return;
    setSaving(true);
    try {
      await reilmAPI.updatedPropertiesDetails(params.row.id, { strategy: selected.value });
      onStrategyUpdate?.(params.row.id, selected.value);
      onSaveOk?.(`strategy:${params.row.id}`);
    } catch (err) {
      onSaveFailed?.(`strategy:${params.row.id}`, err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Select
      value={currentOption}
      options={STRATEGY_OPTIONS}
      onChange={handleChange}
      isDisabled={saving}
      isSearchable={false}
      formatOptionLabel={formatOptionLabel}
      components={{ DropdownIndicator, IndicatorSeparator: null }}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      placeholder="—"
      aria-label="Strategy"
      styles={styles}
    />
  );
};

export default StrategyCellEditor;
